module.exports = __webpack_public_path__ + "img/dnd-box.ffed8ced.png";